import { StyledComponent } from '@emotion/styled';
import { Drawer, DrawerProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const headerHeight = 64;

const prefix = 'HusaRightDrawer';
const classes = {
  drawerPaper: `${prefix}-drawerPaper`,
  dialogToolbar: `${prefix}-dialogToolbar`,
  colorWhite: `${prefix}-colorWhite`,
  grow: `${prefix}-grow`,
  content: `${prefix}-content`
};
const RightDrawer: StyledComponent<DrawerProps> = styled(Drawer)(({ theme }) => ({
  [`& .${classes.drawerPaper}`]: {
    top: headerHeight,
    paddingBottom: headerHeight,
    width: '45%',
    minWidth: 500
  },
  [`& .${classes.dialogToolbar}`]: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(3),
    backgroundColor: theme.palette.primary.light
  },
  [`& .${classes.colorWhite}`]: {
    color: 'white'
  },
  [`& .${classes.grow}`]: {
    flexGrow: 1
  },
  [`& .${classes.content}`]: {
    padding: theme.spacing(2)
  }
}));

export { classes, RightDrawer };
